// extracted by mini-css-extract-plugin
export var displayNone = "_um-6";
export var imgContainer = "_um-2";
export var overflowHidden = "_um-3";
export var productInfoCardButtonContainer = "_um-5";
export var productTitleText = "_um-4";
export var rightArrow = "_um-1";
export var rightArrowContainer = "_um-0";